export const campaignTemplateEditFormValidator = (formValues: any) => {
    const errors = [];
    if(formValues.title.length < 3) {
        errors.push('Please type a meaningful title');
    }
    if(formValues.content.length < 10) {
        errors.push('The content of your message is too short');
    }
    if(formValues.content.length > 900) {
        errors.push('The content of your message is too long');
    }
    return errors;
}